import * as storage from "~utils/storage"
import { Environment } from "../environment"
import { RootStore, RootStoreModel } from "./root-store"
import {
  HAVE_BEEN_PASS_INTRO,
  HAVE_BEEN_PASS_PRIVACY,
  SECURE_STORAGE_KEY_DEVICE_ID,
  STORAGE_KEY_CLIENT_ID,
  SECURE_STORAGE_KEY_TOKEN,
  STORAGE_KEY_TOKEN_FALLBACK,
} from "~utils/storage/storage-keys"
import { secureStorage, tryMigrateFromExpoSecureStore } from "~utils/secureStorage"

export let rootStoreInstance: RootStore
/**
 * Setup the environment that all the models will be sharing.
 *
 * The environment includes other functions that will be picked from some
 * of the models that get created later. This is how we loosly couple things
 * like events between models.
 */
export async function createEnvironment() {
  const env = new Environment()
  await env.setup()
  return env
}

export const getPersistStoreValues = async () => {
  const haveBeenPassIntro = await storage.load(HAVE_BEEN_PASS_INTRO)
  const haveBeenPassPrivacy = await storage.load(HAVE_BEEN_PASS_PRIVACY)
  await tryMigrateFromExpoSecureStore([SECURE_STORAGE_KEY_TOKEN, SECURE_STORAGE_KEY_DEVICE_ID])

  let token = ""
  let keychainAvailable = false
  try {
    keychainAvailable = await secureStorage.isAvailableAsync()
    token = keychainAvailable ? (await secureStorage.getItemAsync(SECURE_STORAGE_KEY_TOKEN)) || "" : ""
  } catch {
    token = ""
  }
  if (!token) {
    token = (await storage.loadString(STORAGE_KEY_TOKEN_FALLBACK)) || ""
  }
  return {
    authStore: {
      token,
      deviceId: (await secureStorage.getItemAsync(SECURE_STORAGE_KEY_DEVICE_ID)) || "",
      clientId: (await storage.load(STORAGE_KEY_CLIENT_ID)) || "",
      haveBeenPassIntro: !!haveBeenPassIntro,
      haveBeenPassPrivacy: !!haveBeenPassPrivacy,
    },
  }
}
export const storageDataMerge = (persistData, userData) => {
  for (const key in persistData) {
    userData[key] = {
      ...persistData[key],
      ...userData[key],
    }
  }
  // token 以持久化安全存储为准，禁止被用户快照中的旧值覆盖
  if (persistData?.authStore) {
    userData.authStore = {
      ...(userData.authStore || {}),
      token: persistData.authStore.token || "",
      deviceId: persistData.authStore.deviceId || userData?.authStore?.deviceId || "",
      clientId: persistData.authStore.clientId || userData?.authStore?.clientId || "",
      haveBeenPassIntro: !!persistData.authStore.haveBeenPassIntro,
      haveBeenPassPrivacy: !!persistData.authStore.haveBeenPassPrivacy,
    }
  }
  return userData
}

/**
 * Setup the root state.
 */
export async function setupRootStore() {
  let data: any = {}

  // prepare the environment that will be associated with the RootStore.
  const env = await createEnvironment()
  try {
    const persistData = await getPersistStoreValues()
    data = storageDataMerge(persistData, data)
  } catch (e) {
    // but please inform us what happened
    __DEV__ && console.tron?.error?.(e.message, null)
  }
  rootStoreInstance = RootStoreModel.create(data, env)
  // reactotron logging (web 无 Reactotron 实例)
  if (__DEV__ && env.reactotron) {
    env.reactotron.setRootStore(rootStoreInstance, data)
  }
  return rootStoreInstance
}
